<template>
  <div :class="contentWidth === 'boxed' ? 'container p-0' : null">
    <router-view />
  </div>
</template>

<script setup>
  import useAppConfig from '@/app-config/useAppConfig'
  const { contentWidth } = useAppConfig()

</script>
